export default "__VITE_ASSET__wtHL46GE__"